import { useState } from "react"
import { QRCodeCanvas } from "qrcode.react"
import { useNavigate } from "react-router-dom"
import { FileText } from "lucide-react"
import { fr } from "../../locales/fr"
import { downloadPaymentInvoice } from "../../services/paymentService"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/Card"
import { Button } from "../../components/ui/Button"
import { PaymentInvoiceModal } from "../../components/payments/PaymentInvoiceModal"
import SelfieQrPanel from "../../components/members/SelfieQrPanel"

export default function StepSuccess({ member, payment }) {
  const w = fr.wizard.stepSuccess
  const navigate = useNavigate()
  const [invoiceOpen, setInvoiceOpen] = useState(false)
  const [photoReady, setPhotoReady] = useState(Boolean(member?.photo))

  const canInvoice = payment && payment.id
  const memberId = member?.id

  return (
    <div className="flex justify-center py-8">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-success">{w.title}</CardTitle>
          <CardDescription>{w.memberNumber}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-lg font-semibold text-foreground">{member.memberNumber}</p>
          {payment?.invoiceNumber ? (
            <p className="text-sm text-muted-foreground">
              Facture : <span className="font-mono text-foreground">{payment.invoiceNumber}</span>
            </p>
          ) : null}
          <div>
            <p className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {w.accessQrLabel}
            </p>
            <div className="flex justify-center rounded-lg bg-white p-3 ring-1 ring-border">
              <QRCodeCanvas
                value={member.memberNumber || member.qrCode || ""}
                size={150}
              />
            </div>
          </div>

          {memberId && !photoReady ? (
            <div className="text-left">
              <SelfieQrPanel
                memberId={memberId}
                currentPhoto={member.photo}
                compact
                onPhotoReceived={() => setPhotoReady(true)}
              />
            </div>
          ) : null}

          {photoReady ? (
            <p className="text-sm text-success">{fr.selfie.received}</p>
          ) : null}

          <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
            {canInvoice ? (
              <>
                <Button
                  type="button"
                  variant="outline"
                  className="gap-2"
                  onClick={() => downloadPaymentInvoice(payment.id)}
                >
                  <FileText className="h-4 w-4" />
                  {w.downloadInvoice}
                </Button>
                <Button type="button" variant="secondary" onClick={() => setInvoiceOpen(true)}>
                  {w.editInvoice}
                </Button>
              </>
            ) : null}
            <Button type="button" onClick={() => navigate("/members")}>
              {w.goMembers}
            </Button>
          </div>
        </CardContent>
      </Card>

      {canInvoice ? (
        <PaymentInvoiceModal
          open={invoiceOpen}
          onClose={() => setInvoiceOpen(false)}
          paymentId={payment.id}
          onSaved={() => {}}
        />
      ) : null}
    </div>
  )
}
